/* eslint-disable */
export interface StateHome {}

export class State implements StateHome {}
